const modelInventoryFeatureLabel = 'Model';
const modelAssociationFeatureLabel = 'Sub-Process';
const modelRequestFeatureLabel = 'Assessment';
const useCaseFeatureLabel = 'NMQT';
const queryFeatureLabel = 'Query';
const accessRequestFeatureLabel = 'Access Request';

// This is our default file, do not edit anything. Please create new config file for different tenants
// Do not try to edit the key part of the object as it is having dependencies everywhere, make sure you understand the code before editing this file.
export const LABEL_CONFIG_07 = {
  MENUS: {
    home: {
      label: 'Home',
      path: 'home',
    },
    inventory: {
      label: 'Inventory',
      path: 'inventory',
    },
    modelInventory: {
      label: 'Models',
      featureLabel: modelInventoryFeatureLabel, // If you are changing this change it in the template type as well
      path: 'models', // If you are changing this parents path, make sure to change it in subPaths as well
      subPaths: {
        createModel: {
          label: 'Add Model',
          path: 'models/add-model',
        },
        editModel: {
          label: 'Edit Model',
          path: 'models/:uniqueId',
        },
        archivedModels: {
          label: 'Archived Models',
          path: 'models/archived',
        },
      },
    },
    modelRequest: {
      label: 'Assessments',
      featureLabel: modelRequestFeatureLabel, // If you are changing this change it in the template type as well
      path: 'assessments', // If you are changing this parents path, make sure to change it in subPaths as well
      subPaths: {
        editModelRequest: {
          label: 'Edit Assessment',
          path: 'assessments/:uniqueId',
        },
        archivedModelRequest: {
          label: 'Archived Assessment',
          path: 'assessments/archived',
        },
      },
    },
    useCase: {
      label: 'NMQT',
      featureLabel: useCaseFeatureLabel, // If you are changing this change it in the template type as well
      path: 'nmqt', // If you are changing this parents path, make sure to change it in subPaths as well
      subPaths: {
        editUseCase: {
          label: 'Edit NMQT',
          path: 'nmqt/:uniqueId',
        },
        archivedUseCase: {
          label: 'Archived NMQT',
          path: 'nmqt/archived',
        },
      },
    },
    query: {
      label: 'Queries',
      featureLabel: queryFeatureLabel,
      path: 'query',
      subPaths: {
        editQuery: {
          label: 'Edit Query',
          path: 'query/:uniqueId',
        },
      },
    },
    ModelAssociation: {
      label: 'Sub-Process',
      featureLabel: modelAssociationFeatureLabel, // If you are changing this change it in the template type as well
      path: 'model-sub-process', // If you are changing this parents path, make sure to change it in subPaths as well
      subPaths: {
        allArtifacts: {
          label: 'All Sub-Process',
          path: 'model-sub-process',
        },
        editModelAssociation: {
          label: 'Edit Sub-Process',
          path: 'model-sub-process/:uniqueId',
        },
        archivedArtifacts: {
          label: 'Archived Sub-Process',
          path: 'model-sub-process/archived',
        },
      },
    },
    DocumentInventory: {
      label: 'Documents',
      path: 'documents',
    },
    rules: {
      label: 'Rules',
      path: 'rules',
    },
    report: {
      label: 'Reports',
      path: 'reports',
    },
    bulkActions: {
      label: 'Bulk Actions',
      path: 'bulk-actions',
    },
    bulkUpload: {
      label: 'Bulk Upload',
      path: 'bulk-upload',
    },
    bulkTransition: {
      label: 'Bulk Transition',
      path: 'bulk-transition',
    },
    bulkUpdate: {
      label: 'Bulk Update',
      path: 'bulk-update',
    },
    bulkDocumentUpload: {
      label: 'Bulk Document Upload',
      path: 'bulk-document',
    },
    Configuration: {
      label: 'Configuration',
      path: 'configuration',
    },
    globalAttributes: {
      label: 'Global Attributes',
      featureLabel: 'Global Attributes',
      path: 'global-attributes',
    },
    Attributes: {
      label: 'Attributes',
      featureLabel: 'Attributes',
      path: 'attributes',
    },
    constantAttributes: {
      label: 'Constant Attributes',
      featureLabel: 'Constant Attributes',
      path: 'constant-attributes',
    },
    teamRoles: {
      label: 'Team Roles',
      featureLabel: 'Team Roles',
      path: 'team-roles',
    },
    workflow: {
      label: 'Workflows',
      featureLabel: 'Workflow',
      path: 'workflows', // If you are changing this parents path, make sure to change it in subPaths as well
      subPaths: {
        editWorkflow: {
          label: 'Edit Workflow',
          path: 'workflows/edit-workflow',
        },
        generateWorkflow: {
          label: 'Generate Workflow',
          path: 'workflows/generate-workflow',
        },
      },
    },
    templateList: {
      label: 'Templates',
      path: 'templates', // If you are changing this parents path, make sure to change it in subPaths as well
      subPaths: {
        createTemplate: {
          label: 'Create Template',
          path: 'templates/create-template',
        },
        editTemplate: {
          label: 'Edit Template',
          path: 'templates/edit-template',
        },
      },
    },
    documentTemplate: {
      label: 'Document Template',
      path: 'document-template',
    },
    dynamicChart: {
      label: 'Dynamic Chart',
      path: 'dynamic-chart',
    },
    automation: {
      label: 'Automation',
      path: 'automation', // If you are changing this parents path, make sure to change it in subPaths as well
      subPaths: {
        createAutomation: {
          label: 'Create Automation',
          path: 'automation/create-automation',
        },
        updateAutomation: {
          label: 'Update Automation',
          path: 'automation/update-automation',
        },
      },
    },
    themeAndAppearance: {
      label: 'Theme and Appearance',
      path: 'theme-and-appearance',
    },
    emailTemplate: {
      label: 'Email Template',
      path: 'email-template',
      subPaths: {
        createEmailTemplate: {
          label: 'Create Email Template',
          path: 'email-template/create-email-template',
        },
        editEmailTemplate: {
          label: 'Edit Email Template',
          path: 'email-template/:uniqueId',
        },
      },
    },
    helpAndSupport: {
      label: 'Help and Support',
      path: 'help',
    },
    administrativeOptions: {
      label: 'Administrative Options',
      path: 'administrative-options',
    },
    userManagement: {
      label: 'User Management',
      path: 'user-management',
    },
    appManagement: {
      label: 'App Management',
      path: 'app-management',
    },
    emailManagement: {
      label: 'Email Management',
      path: 'email-management',
    },
    documentInventory: {
      label: 'Documents',
      path: 'documents',
    },
    accessRequest: {
      label: 'Access Request',
      featureLabel: accessRequestFeatureLabel, // If you are changing this change it in the template type as well
      path: 'accessRequest', // If you are changing this parents path, make sure to change it in subPaths as well
      subPaths: {
        editAccessRequest: {
          label: 'Edit Access Request',
          path: 'accessRequest/:uniqueId',
        },
      },
    },
    homepageSetup: {
      label: 'Homepage Setup',
      path: 'homepage-setup',
    },
    systemId: {
      label: 'System ID',
      path: 'system-id',
    },
    idViaTemplate: {
      label: 'ID via Template',
      path: 'id-via-template',
    },
    entityManagement: {
      label: 'Entity Management',
      path: 'entity-management',
    },
    logs: {
      label: 'Logs',
      path: 'logs',
      subPaths: {
        configurationLogs: {
          label: 'System Logs',
          path: 'logs/system-logs',
        },
      },
    },
  },
  LABELS: {
    modelInventory: {
      otherDetails: {
        label: 'Other Details',
      },
      modelLifecycleEventDropdown: {
        label: 'Template Name',
      },
      relatedProcessTabLabel: {
        label: 'Other {issueTypeName}',
      },
      table: {
        column: {
          ModelHealth: {
            label: 'Model Health',
          },
        },
      },
    },
    modelAssociation: {
      otherDetails: {
        label: 'Sub-Process Template',
      },
      artifactLifecycleEventDropdown: {
        label: 'Template Name',
      },
      table: {
        column: {
          ArtifactHealth: {
            label: 'Sub-Process Health',
          },
        },
      },
    },
    useCase: {
      usecaseLifecycleEventDropdown: {
        label: 'Template Name',
      },
    },
    query: {
      queryLifecycleEventDropdown: {
        label: 'Template Name',
      },
    },
    modelRequest: {
      modelRequestLifecycleEventDropdown: {
        label: 'Template Name',
      },
    },
    userManagement: {
      groups: {
        label: 'Groups',
        uppercaseLabel: 'GROUPS',
      },
      group: {
        label: 'Group',
        uppercaseLabel: 'GROUP',
      },
      table: {
        column: {
          role: {
            label: 'ROLE',
          },
        },
      },
    },
  },
  // If you are changing this part, then make sure you are changing the paths and menus labels to these.
  TEMPLATE_TYPES: {
    ModelInventory: {
      label: 'Model',
      featureLabel: modelInventoryFeatureLabel, // This feature label is used to show in the places where we want to show different name instead of we show in dropdown, for example our ModelInventory label is ModelInventory but we show it as Model everywhere.
      // If you are changing this change it in the Menus as well
    },
    ModelAssociation: {
      label: 'Sub-Process',
      featureLabel: modelAssociationFeatureLabel, // This feature label is used to show in the places where we want to show different name instead of we show in dropdown, for example our ModelInventory label is ModelInventory but we show it as Model everywhere.
      // If you are changing this change it in the Menus as well
    },
    ModelRequest: {
      label: 'Assessment',
      featureLabel: modelRequestFeatureLabel, // This feature label is used to show in the places where we want to show different name instead of we show in dropdown, for example our ModelInventory label is ModelInventory but we show it as Model everywhere.
      // If you are changing this change it in the Menus as well
    },
    AccessRequest: {
      label: 'Access Request',
      featureLabel: accessRequestFeatureLabel, // This feature label is used to show in the places where we want to show different name instead of we show in dropdown, for example our ModelInventory label is ModelInventory but we show it as Model everywhere.
      // If you are changing this change it in the Menus as well
    },
    UseCase: {
      label: 'NMQT',
      featureLabel: useCaseFeatureLabel, // This feature label is used to show in the places where we want to show different name instead of we show in dropdown, for example our ModelInventory label is ModelInventory but we show it as Model everywhere.
      // If you are changing this change it in the Menus as well
    },
    Query: {
      label: 'Query',
      featureLabel: queryFeatureLabel,
    },
  },
};
